'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A wrapper around the slides.
 * This will help with the layout e.g. adding
 * padding to Deck and therefore allowing absolute posiitoned
 * static elements via the `Elements` component.
 * @private
 */
var SlidesWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'slides-wrapper__SlidesWrapper'
})(['flex:1;height:100%;width:100%;position:relative;overflow:hidden;']);

/**
 * Allowed propTypes for `<SlidesWrapper/>`
 * @private
 * @param {Array<Deck.visibleSlides>} children
 * @type {Object}
 */
SlidesWrapper.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.element)
};

exports.default = SlidesWrapper;